import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import DetailPageHeader from '../../pages/markets/component/detail-page-header';
import FuturesAndOptionsFaq from '../../pages/markets/component/futures-and-options-faq';
import FuturesExternalSearch from '../../pages/markets/component/futures-external-search';
import MostActiveIndexOptionsExternal from '../../pages/markets/component/most-active-index-options-external';
import '../../pages/markets/pages/options-external-most-active-index/options-external-most-active-index.m.css';

const MostActiveIndexOptionsFull = () => {
  const queryClient = new QueryClient();
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        {initialLoading ? (
          <div styleName="initial-loading-container"></div>
        ) : (
          <div styleName="detail-header-container">
            <div className="container">
              <DetailPageHeader widget={true} />
            </div>
          </div>
        )}

        <div styleName="overall-container">
          <div styleName="search-widget-container" className="container">
            <FuturesExternalSearch />

            <MostActiveIndexOptionsExternal />
          </div>
        </div>
        <div className="container">
          <FuturesAndOptionsFaq widget={true} />
        </div>
      </>
    </QueryClientProvider>
  );
};

export default MostActiveIndexOptionsFull;
